import { type FC, lazy, Suspense, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  RequiredLabel,
  TextField,
  ValidationErrorMessage,
  Pulldown,
} from "@legacy_user_frontend/components/ui_parts";
import { BoxWithShadow } from "@legacy_user_frontend/components/pages/mypage/profiles/ui_parts/box_with_shadow";
import { DefinitionList } from "@legacy_user_frontend/components/pages/mypage/profiles/ui_parts/definition_list";
import { DeleteTextLinkButton } from "@legacy_user_frontend/components/pages/mypage/profiles/ui_parts/delete_text_button";
import { type CassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/achievement_edit/src/achievement_edit_props";
import * as styles from "@legacy_user_frontend/components/pages/mypage/profiles/achievement_edit/src/styles.css";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";

const ConfirmModal = lazy(() =>
  retryLazyLoad({
    fn: () =>
      import("@legacy_user_frontend/components/pages/mypage/profiles/achievement_edit/src/confirm_modal"),
  }),
);

export const Cassette: FC<CassetteProps> = ({
  cassetteIndex,
  removeCassette,
  formName,
  yearList,
  monthList,
}) => {
  // バリデーションエラー周りの処理
  const {
    formState: { errors },
  } = useFormContext();
  const validateErrors = errors?.form_user_achievement_collection?.user_achievements_attributes;
  const fieldError = validateErrors && validateErrors.length && validateErrors[cassetteIndex];
  const nameError = fieldError && fieldError.name;
  const yearError = fieldError && fieldError.year;
  const monthError = fieldError && fieldError.month;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <BoxWithShadow>
      <div className={styles.cassetteHeadingOuter} id={`cassette-${cassetteIndex}`}>
        <p className={styles.cassetteHeading}>受賞・表彰歴 {1 + cassetteIndex}</p>
        <DeleteTextLinkButton type="button" onClick={openModal} size="small">
          削除する
        </DeleteTextLinkButton>
      </div>
      <DefinitionList>
        <dt>
          名称
          <span className="required-label-outer">
            <RequiredLabel />
          </span>
        </dt>
        <dd>
          <TextField
            name={`${formName}[${cassetteIndex}][name]`}
            placeholder="例）リジョブコンテスト最優秀賞"
            isError={!!nameError}
          />
          {nameError && nameError.message && (
            <div className={styles.errorMessageOuter}>
              <ValidationErrorMessage message={nameError.message} />
            </div>
          )}
        </dd>
        <dt>年月</dt>
        <dd>
          <div className={styles.dateSelectOuter}>
            <Pulldown
              name={`${formName}[${cassetteIndex}][year]`}
              placeholder="年"
              list={yearList}
              isError={!!yearError}
              errorName={`${formName}[${cassetteIndex}][name]`}
            />
            <Pulldown
              name={`${formName}[${cassetteIndex}][month]`}
              placeholder="月"
              list={monthList}
              isError={!!monthError}
              errorName={`${formName}[${cassetteIndex}][name]`}
            />
          </div>
          {(yearError || monthError) && (
            <div className={styles.errorMessageOuter}>
              {yearError && yearError.message && (
                <ValidationErrorMessage message={yearError.message} />
              )}
              {monthError && monthError.message && (
                <ValidationErrorMessage message={monthError.message} />
              )}
            </div>
          )}
        </dd>
      </DefinitionList>
      <Suspense fallback={null}>
        {isModalOpen && (
          <ConfirmModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            cassetteIndex={cassetteIndex}
            removeCassette={removeCassette}
          />
        )}
      </Suspense>
    </BoxWithShadow>
  );
};
